import { Col, Container} from "react-bootstrap";

export default function Banner() {
  return (
    <Container fluid className="pb-5 bannerPosition">
      <Col className="herobanner" xs={12} md={12} lg={12} sm={12} />
    </Container>
  );
}
